<!-- 
BenefitsTimesModal.vue
功能：VIP權益次數視窗
作者：i94004v014 Hugo
完成：2026-03-06
-->
<template>
  <div id="benefits-times-modal" class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog" style="width: 700px;">
      <div class="modal-content">
        <!-- modal-header：padding 23px 40px，背景 #e8f3e1 -->
        <div class="modal-header btm-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>

          <div class="col-12 pl-0">
            <h3 class="modal-title text-center">
              <template v-if="benefitsData && benefitsData.web_member =='Y'">
                可使用權益次數:
                <span class="btm-times ml-3">{{benefitsData.surplus_times}}次</span>
              </template>

              <template v-else-if="benefitsData && benefitsData.web_member =='N'">
                <span class="btm-header-red">尚未申辦官網會員</span>
              </template>
            </h3>
          </div>
        </div>

        <!-- modal-body -->
        <div class="modal-body btm-body mb-2" :class="{ 'section-loading': isLoading }">
          <!-- 注意事項：紅色 -->
          <div class="btm-notice">
            ※權益資格注意事項
            <br>⚠️VIP保戶須加入國泰人壽官網會員方可使用權益次數
          </div>

          <div class="btm-section">
            <div class="btm-title">●VIP權益次數</div>
            <div class="btm-content">
              <div class="w-600">1.尊榮禮遇次數：</div>
              <div>鑽石級VIP：每年5次</div>
              <div>白金級VIP：每年2次</div>
              <div class="w-600">2.額外權益次數：</div>
              <div>限國泰一家人家庭成員當年度有結婚或生子，即可線上申請額外權益，申請完成均發放1次權益歸戶VIP戶長本人(家庭成員每人每年限申請一次) 。</div>
            </div>
          </div>

          <div class="btm-section">
            <div class="btm-title">●權益次數兌換方式</div>
            <div class="btm-content">
              <div>1. VIP CLUB/會員登入/尊榮禮遇/VIP權益兌換/點選「點我兌換」</div>
              <div>2. 於VIP CLUB查詢權益兌換專線，由專人協助兌換</div> 
            </div>
          </div>

          <div class="btm-section">
            <div class="btm-title">●權益使用期限</div>
            <div class="btm-content">
              <div>發放日至隔年年底</div>
            </div>
          </div>

          <div class="btm-section">
            <div class="btm-title">●權益使用對象</div>
            <div class="btm-content">
              <div>1. 鑽石VIP、2. 白金VIP、3. 權益次數尚未到期但已 非鑽石或白金VIP等級者</div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCathayFamilyBenefits } from "@/service";
import Tooltip from "@/desktop/components/ToolTip";
import { mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
export default {
  name: "BenefitsTimesModal",
  mixins: [commonMixin],
  components: { Tooltip },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    csid: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["UserInfo"]),
  },
  watch: {
    open: function(val) {
      if (val) {
        this.init();
      }
    }
  },
  data() {
    return {
      isLoading: false,
      benefitsData: {}
    };
  },
  methods: {
    init() {
      this.benefitsData = [];
      if (this.csid) {
        this.isLoading = true;
        getCathayFamilyBenefits(
          this.$store.state.userInfo.id,
          this.csid
        ).then(result => {
          this.isLoading = false;
          if (
            result.header &&
            result.header.status === "200" &&
            result.body.result
          ) {
            this.benefitsData = result.body.result || {};
            this.registerHanlink(); // for hard word
          } else {
            this.benefitsData = {};
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.btm-header {
  padding: 23px 40px !important;
  background: #e8f3e1 !important;
}

.btm-times {
  color: #DE4054;
  font-weight: 700;
}

.btm-header-red {
  color: #DE4054 !important; 
  font-weight: 700;
}

.btm-body {
  padding-top: 14px;
  line-height: 1.5; 
}

.btm-notice {
  color: #DE4054;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 6px;
}

.btm-section {
  margin-bottom: 6px;
}

.btm-title {
  color: #1442c4;
  margin-bottom: 2px;
  //padding-left: 20px; 
  font-weight: 700;
  font-size: 20px;
}

.btm-content {
  margin-left: 20px;
  font-size: 20px;
}

.btn-content > div {
  margin-bottom: 1px;
}

.w-600 {
  font-weight: 600;
}
</style>